import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { graphcms, QUERY_HOMEPAGE_ABOUT_US } from "../Graphql/Queries";
import { Skeleton } from "@/components/ui/skeleton";

function HomeAboutUs() {
  const [aboutUs, setAboutUs] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    graphcms.request(QUERY_HOMEPAGE_ABOUT_US).then((res) => {
      setAboutUs(res.aboutUs);
      setLoading(false);
    });
  }, []);

  return (
    <div className="container mt-28 mb-16 lg:my-30 w-11/12 lg:w-10/12 mx-auto flex flex-col items-center justify-around ">
      <div className="text-2xl font-bold mb-5 lg:text-2xl">About Us</div>
      {loading ? (
        <div className="w-full space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-11/12" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      ) : (
        <p className="text-sm indent-10 lg:text-lg">
          {aboutUs?.summarizedAboutUs}
        </p>
      )}
      <Link to={"/about"}>
        <button className="mt-7 py-2 px-4 bg-sky-600 text-white rounded-lg m-auto text-base">
          Read More
        </button>
      </Link>
    </div>
  );
}

export default HomeAboutUs;
